export enum SortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export enum BannersPlacementSlug {
  HOMEPAGE_BELOW_SEARCH = "HOMEPAGE_BELOW_SEARCH",
  CHECKOUT = "CHECKOUT",
}
